import { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import SubmitButton from 'components/ui/buttons/SubmitButton';
import withModalView from 'components/ui/withModalView';
import withAuthorizer from 'components/ui/withAuthorizer';

import { Resources } from 'helpers/ResourceHelper';

import BotReportApi from 'api/bot-report';

const AddJobPage = ({ backUrl }) => {
  const { t } = useTranslation();

  const [saving, setSaving] = useState(false);
  const { botId } = useParams();
  const history = useHistory();

  const onSubmit = async e => {
    e.preventDefault();

    const formDataObj = new FormData(e.target);
    const formData = Object.fromEntries(formDataObj);

    setSaving(true);

    try {
      formData.bot_id = botId;
      const data = await BotReportApi.create(formData);
      history.push(`/botreports/${data.id}/edit`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="container">
        <h3>{t('bots.reports.add.title')}</h3>
      </div>

      <form className="container mt-4" id="form-item" onSubmit={onSubmit}>
        <div className="mb-3">
          <label htmlFor="inputName" className="form-label">
            {t('bots.reports.add.form.name.label')}:
          </label>
          <input type="text" name="name" className="form-control" id="inputName" required />
        </div>

        <div className="mb-3">
          <label htmlFor="inputDescription" className="form-label">
            {t('bots.reports.add.form.description.label')}:
          </label>
          <textarea name="description" className="form-control" id="inputDescription"></textarea>
        </div>

        <hr />

        <div className="text-right">
          <SubmitButton className="btn btn-primary" tkey="actions.create" loading={saving} />
        </div>
      </form>
    </>
  );
};

export default withModalView(withAuthorizer(AddJobPage, [Resources.BOT_MANAGER]));
